export default __webpack_public_path__ + "static/JH2_3817-edited2000px-9b376b4736a36741404532fad0580889.jpg";